import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { User, Bookmark, LogOut, LogIn } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const UserMenu = () => {
  const { user, isAuthenticated, loading, login, logout } = useAuth();

  if (loading) {
    return (
      <div className="w-8 h-8 rounded-full bg-[#121917] animate-pulse" />
    );
  }

  if (!isAuthenticated) {
    return (
      <button
        onClick={login}
        className="flex items-center gap-2 px-3 py-2 text-[#E6FFF6] hover:text-[#52ea88] transition-colors"
      >
        <LogIn className="w-4 h-4" />
        <span className="hidden sm:inline text-sm">Sign In</span>
      </button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="outline-none">
        {user?.picture ? (
          <img
            src={user.picture}
            alt={user.name}
            className="w-8 h-8 rounded-full border border-[#52ea88]/30 hover:border-[#52ea88] transition-colors"
          />
        ) : (
          <div className="w-8 h-8 rounded-full bg-[#52ea88]/20 flex items-center justify-center text-[#52ea88] hover:bg-[#52ea88]/30 transition-colors">
            <User className="w-4 h-4" />
          </div>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-[#121917] border border-[#52ea88]/15 min-w-[200px]"
      >
        <div className="px-4 py-3 border-b border-[#52ea88]/10">
          <p className="text-sm font-medium text-[#E6FFF6]">{user?.name}</p>
          <p className="text-xs text-[#9FBFB4] truncate">{user?.email}</p>
        </div>
        
        <DropdownMenuItem asChild>
          <Link
            to="/bookmarks"
            className="flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-[#52ea88]/5 text-[#E6FFF6]"
          >
            <Bookmark className="w-4 h-4 text-[#52ea88]" />
            <span>Saved Reviews</span>
          </Link>
        </DropdownMenuItem>
        
        <DropdownMenuSeparator className="bg-[#52ea88]/10" />
        
        <DropdownMenuItem
          onClick={logout}
          className="flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-[#52ea88]/5 text-[#9FBFB4]"
        >
          <LogOut className="w-4 h-4" />
          <span>Sign Out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserMenu;
